module.exports = __webpack_public_path__ + "img/overview-latest.d9331da6.svg";